import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
import LocationOn from "@material-ui/icons/LocationOn";
import School from "@material-ui/icons/School";
// core components
import boxShadows from "assets/theme/box-shadow.js";

function CardProfile() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
      >
        <Box
          component="img"
          alt="..."
          src={require("assets/img/theme/img-1-1000x600.jpg").default}
          sx={{
            borderTopLeftRadius: "calc(.375rem - 1px)",
            borderTopRightRadius: "calc(.375rem - 1px)",
            flexShrink: 0,
            width: "100%",
            verticalAlign: "middle",
            borderStyle: "none",
          }}
        />
        <Box component={Grid} container sx={{ justifyContent: "center" }}>
          <Grid item xs={12} lg={3}>
            <Box
              component="img"
              src={require("assets/img/theme/team-4-800x800.jpg").default}
              alt="..."
              sx={{
                maxWidth: "140px",
                borderRadius: "50%",
                position: "absolute",
                left: "50%",
                border: "3px solid " + theme.palette.white.main,
                boxShadow: boxShadows.boxShadow + "!important",
                verticalAlign: "middle",
                transform: "translate(-50%,-50%) scale(1)",
                transition: "all .15s ease",
                "&:hover": {
                  transform: "translate(-50%,-50%) scale(1.03)",
                },
              }}
            />
          </Grid>
        </Box>
        <Box
          component={CardHeader}
          sx={{
            border: "0!important",
            textAlign: "center",
            paddingBottom: "0!important",
            paddingTop: "8rem!important",
            [theme.breakpoints.up("sm")]: {
              paddingBottom: "1.5rem!important",
              paddingTop: "1.5rem!important",
            },
          }}
          subheader={
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button variant="contained" color="info" size="small">
                Connect
              </Button>
              <Button variant="contained" color="dark" size="small">
                Message
              </Button>
            </Box>
          }
        ></Box>
        <Box component={CardContent} sx={{ paddingTop: "0!important" }}>
          <Grid container>
            <Grid item xs={12}>
              <Box
                sx={{
                  padding: "1rem 0",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    textAlign: "center",
                    marginRight: "1rem",
                    padding: ".875rem",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: "700",
                      display: "block",
                      letterSpacing: ".025em",
                      textTransform: "uppercase",
                    }}
                  >
                    22
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontSize: ".875rem",
                      color: theme.palette.gray[500],
                    }}
                  >
                    Friends
                  </Box>
                </Box>
                <Box
                  sx={{
                    textAlign: "center",
                    marginRight: "1rem",
                    padding: ".875rem",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: "700",
                      display: "block",
                      letterSpacing: ".025em",
                      textTransform: "uppercase",
                    }}
                  >
                    10
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontSize: ".875rem",
                      color: theme.palette.gray[500],
                    }}
                  >
                    Photos
                  </Box>
                </Box>
                <Box sx={{ textAlign: "center", padding: ".875rem" }}>
                  <Box
                    component="span"
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: "700",
                      display: "block",
                      letterSpacing: ".025em",
                      textTransform: "uppercase",
                    }}
                  >
                    89
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontSize: ".875rem",
                      color: theme.palette.gray[500],
                    }}
                  >
                    Comments
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h3">
              Jessica Jones
              <Box component="span" sx={{ fontWeight: "300" }}>
                , 27
              </Box>
            </Typography>
            <Box
              component={Typography}
              variant="h5"
              sx={{
                fontWeight: "300!important",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                component={LocationOn}
                sx={{ width: "1.25rem!important", height: "1.25rem!important" }}
              ></Box>
              Bucharest, Romania
            </Box>
            <Box
              component={Typography}
              variant="h5"
              sx={{ marginTop: "2rem!important" }}
            >
              Solution Manager - Creative Tim Officer
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1rem",
              }}
            >
              <Box
                component={School}
                sx={{
                  width: "1.25rem!important",
                  height: "1.25rem!important",
                  marginRight: ".5rem",
                }}
              ></Box>
              University of Computer Science
            </Box>
          </Box>
        </Box>
      </Card>
    </>
  );
}

export default CardProfile;
